// extracted by mini-css-extract-plugin
export default {"balanceContainer":"balance_balanceContainer__5KcfP","title":"balance_title__lZ2zu"};